/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  UserEarnOfferListResponse,
  UtxEarnOffersListOffersParams,
  UserEarnDetailResponse,
  UserEarnActionListResponse,
  UtxEarnSubscriptionsGetEarnActionListParams,
  UserSubscriptionOverviewResponse,
  UtxEarnSubscriptionsGetOverviewParams,
  UserSubscriptionAnalyticsResponse,
  UtxEarnSubscriptionsGetAnalyticsParams,
  EarnSubscriptionDetails,
  EarnSubscriptionResponse,
  UserSubscriptionRequest,
  UserRedemptionResponse,
  UserRedemptionRequest,
  UserSubscriptionPreviewResponse,
  UserSubscriptionPreviewRequest,
  EarnSubscriptionAutoRenewalResponse,
  EarnSubscriptionAutoRenewalRequest
} from './schema'



export const utxEarnEnableEarn = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/earn/enable`,undefined,options
    );
  }



    export type UtxEarnEnableEarnMutationResult = NonNullable<Awaited<ReturnType<typeof utxEarnEnableEarn>>>
    
    export type UtxEarnEnableEarnMutationError = AxiosError<unknown>

    export const useUtxEarnEnableEarn = <TError = AxiosError<unknown>,
    TVariables = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxEarnEnableEarn>>, TError,TVariables, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxEarnEnableEarn>>, TVariables> = () => {
          

          return  utxEarnEnableEarn(axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxEarnEnableEarn>>, TError, TVariables, TContext>(mutationFn, mutationOptions)
    }
    export const utxEarnOffersListOffers = (
    params: UtxEarnOffersListOffersParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserEarnOfferListResponse>> => {
    return axios.get(
      `/earn/offers`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxEarnOffersListOffersQueryKey = (params: UtxEarnOffersListOffersParams,) => [`/earn/offers`, ...(params ? [params]: [])];

    
export type UtxEarnOffersListOffersQueryResult = NonNullable<Awaited<ReturnType<typeof utxEarnOffersListOffers>>>
export type UtxEarnOffersListOffersQueryError = AxiosError<unknown>

export const useUtxEarnOffersListOffers = <TData = Awaited<ReturnType<typeof utxEarnOffersListOffers>>, TError = AxiosError<unknown>>(
 params: UtxEarnOffersListOffersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxEarnOffersListOffers>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxEarnOffersListOffersQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxEarnOffersListOffers>>> = ({ signal }) => utxEarnOffersListOffers(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxEarnOffersListOffers>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxEarnOffersGet = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserEarnDetailResponse>> => {
    return axios.get(
      `/earn/offers/${id}`,options
    );
  }


export const getUtxEarnOffersGetQueryKey = (id: string,) => [`/earn/offers/${id}`];

    
export type UtxEarnOffersGetQueryResult = NonNullable<Awaited<ReturnType<typeof utxEarnOffersGet>>>
export type UtxEarnOffersGetQueryError = AxiosError<unknown>

export const useUtxEarnOffersGet = <TData = Awaited<ReturnType<typeof utxEarnOffersGet>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxEarnOffersGet>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxEarnOffersGetQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxEarnOffersGet>>> = ({ signal }) => utxEarnOffersGet(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxEarnOffersGet>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxEarnSubscriptionsGetEarnActionList = (
    params?: UtxEarnSubscriptionsGetEarnActionListParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserEarnActionListResponse>> => {
    return axios.get(
      `/earn/subscriptions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxEarnSubscriptionsGetEarnActionListQueryKey = (params?: UtxEarnSubscriptionsGetEarnActionListParams,) => [`/earn/subscriptions`, ...(params ? [params]: [])];

    
export type UtxEarnSubscriptionsGetEarnActionListQueryResult = NonNullable<Awaited<ReturnType<typeof utxEarnSubscriptionsGetEarnActionList>>>
export type UtxEarnSubscriptionsGetEarnActionListQueryError = AxiosError<unknown>

export const useUtxEarnSubscriptionsGetEarnActionList = <TData = Awaited<ReturnType<typeof utxEarnSubscriptionsGetEarnActionList>>, TError = AxiosError<unknown>>(
 params?: UtxEarnSubscriptionsGetEarnActionListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxEarnSubscriptionsGetEarnActionList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxEarnSubscriptionsGetEarnActionListQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxEarnSubscriptionsGetEarnActionList>>> = ({ signal }) => utxEarnSubscriptionsGetEarnActionList(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxEarnSubscriptionsGetEarnActionList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxEarnSubscriptionsGetOverview = (
    params?: UtxEarnSubscriptionsGetOverviewParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserSubscriptionOverviewResponse>> => {
    return axios.get(
      `/earn/subscriptions/overview`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxEarnSubscriptionsGetOverviewQueryKey = (params?: UtxEarnSubscriptionsGetOverviewParams,) => [`/earn/subscriptions/overview`, ...(params ? [params]: [])];

    
export type UtxEarnSubscriptionsGetOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof utxEarnSubscriptionsGetOverview>>>
export type UtxEarnSubscriptionsGetOverviewQueryError = AxiosError<unknown>

export const useUtxEarnSubscriptionsGetOverview = <TData = Awaited<ReturnType<typeof utxEarnSubscriptionsGetOverview>>, TError = AxiosError<unknown>>(
 params?: UtxEarnSubscriptionsGetOverviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxEarnSubscriptionsGetOverview>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxEarnSubscriptionsGetOverviewQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxEarnSubscriptionsGetOverview>>> = ({ signal }) => utxEarnSubscriptionsGetOverview(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxEarnSubscriptionsGetOverview>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxEarnSubscriptionsGetAnalytics = (
    params?: UtxEarnSubscriptionsGetAnalyticsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserSubscriptionAnalyticsResponse>> => {
    return axios.get(
      `/earn/subscriptions/analytics`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxEarnSubscriptionsGetAnalyticsQueryKey = (params?: UtxEarnSubscriptionsGetAnalyticsParams,) => [`/earn/subscriptions/analytics`, ...(params ? [params]: [])];

    
export type UtxEarnSubscriptionsGetAnalyticsQueryResult = NonNullable<Awaited<ReturnType<typeof utxEarnSubscriptionsGetAnalytics>>>
export type UtxEarnSubscriptionsGetAnalyticsQueryError = AxiosError<unknown>

export const useUtxEarnSubscriptionsGetAnalytics = <TData = Awaited<ReturnType<typeof utxEarnSubscriptionsGetAnalytics>>, TError = AxiosError<unknown>>(
 params?: UtxEarnSubscriptionsGetAnalyticsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxEarnSubscriptionsGetAnalytics>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxEarnSubscriptionsGetAnalyticsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxEarnSubscriptionsGetAnalytics>>> = ({ signal }) => utxEarnSubscriptionsGetAnalytics(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxEarnSubscriptionsGetAnalytics>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxEarnSubscriptionsGetSubscriptionDetail = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EarnSubscriptionDetails>> => {
    return axios.get(
      `/earn/subscriptions/${id}`,options
    );
  }


export const getUtxEarnSubscriptionsGetSubscriptionDetailQueryKey = (id: string,) => [`/earn/subscriptions/${id}`];

    
export type UtxEarnSubscriptionsGetSubscriptionDetailQueryResult = NonNullable<Awaited<ReturnType<typeof utxEarnSubscriptionsGetSubscriptionDetail>>>
export type UtxEarnSubscriptionsGetSubscriptionDetailQueryError = AxiosError<unknown>

export const useUtxEarnSubscriptionsGetSubscriptionDetail = <TData = Awaited<ReturnType<typeof utxEarnSubscriptionsGetSubscriptionDetail>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxEarnSubscriptionsGetSubscriptionDetail>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxEarnSubscriptionsGetSubscriptionDetailQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxEarnSubscriptionsGetSubscriptionDetail>>> = ({ signal }) => utxEarnSubscriptionsGetSubscriptionDetail(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxEarnSubscriptionsGetSubscriptionDetail>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxEarnSubscriptionsSubscribe = (
    userSubscriptionRequest: UserSubscriptionRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    return axios.post(
      `/earn/subscriptions/subscribe`,
      userSubscriptionRequest,options
    );
  }



    export type UtxEarnSubscriptionsSubscribeMutationResult = NonNullable<Awaited<ReturnType<typeof utxEarnSubscriptionsSubscribe>>>
    export type UtxEarnSubscriptionsSubscribeMutationBody = UserSubscriptionRequest
    export type UtxEarnSubscriptionsSubscribeMutationError = AxiosError<EarnSubscriptionResponse>

    export const useUtxEarnSubscriptionsSubscribe = <TError = AxiosError<EarnSubscriptionResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxEarnSubscriptionsSubscribe>>, TError,{data: UserSubscriptionRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxEarnSubscriptionsSubscribe>>, {data: UserSubscriptionRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxEarnSubscriptionsSubscribe(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxEarnSubscriptionsSubscribe>>, TError, {data: UserSubscriptionRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxEarnSubscriptionsRedeem = (
    userRedemptionRequest: UserRedemptionRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    return axios.post(
      `/earn/subscriptions/redeem`,
      userRedemptionRequest,options
    );
  }



    export type UtxEarnSubscriptionsRedeemMutationResult = NonNullable<Awaited<ReturnType<typeof utxEarnSubscriptionsRedeem>>>
    export type UtxEarnSubscriptionsRedeemMutationBody = UserRedemptionRequest
    export type UtxEarnSubscriptionsRedeemMutationError = AxiosError<UserRedemptionResponse>

    export const useUtxEarnSubscriptionsRedeem = <TError = AxiosError<UserRedemptionResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxEarnSubscriptionsRedeem>>, TError,{data: UserRedemptionRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxEarnSubscriptionsRedeem>>, {data: UserRedemptionRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxEarnSubscriptionsRedeem(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxEarnSubscriptionsRedeem>>, TError, {data: UserRedemptionRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxEarnSubscriptionsGetPreview = (
    userSubscriptionPreviewRequest: UserSubscriptionPreviewRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    return axios.post(
      `/earn/subscriptions/preview`,
      userSubscriptionPreviewRequest,options
    );
  }



    export type UtxEarnSubscriptionsGetPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof utxEarnSubscriptionsGetPreview>>>
    export type UtxEarnSubscriptionsGetPreviewMutationBody = UserSubscriptionPreviewRequest
    export type UtxEarnSubscriptionsGetPreviewMutationError = AxiosError<UserSubscriptionPreviewResponse>

    export const useUtxEarnSubscriptionsGetPreview = <TError = AxiosError<UserSubscriptionPreviewResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxEarnSubscriptionsGetPreview>>, TError,{data: UserSubscriptionPreviewRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxEarnSubscriptionsGetPreview>>, {data: UserSubscriptionPreviewRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxEarnSubscriptionsGetPreview(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxEarnSubscriptionsGetPreview>>, TError, {data: UserSubscriptionPreviewRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxEarnSubscriptionsAutoRenewal = (
    earnSubscriptionAutoRenewalRequest: EarnSubscriptionAutoRenewalRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    return axios.post(
      `/earn/subscriptions/auto-renewal`,
      earnSubscriptionAutoRenewalRequest,options
    );
  }



    export type UtxEarnSubscriptionsAutoRenewalMutationResult = NonNullable<Awaited<ReturnType<typeof utxEarnSubscriptionsAutoRenewal>>>
    export type UtxEarnSubscriptionsAutoRenewalMutationBody = EarnSubscriptionAutoRenewalRequest
    export type UtxEarnSubscriptionsAutoRenewalMutationError = AxiosError<EarnSubscriptionAutoRenewalResponse>

    export const useUtxEarnSubscriptionsAutoRenewal = <TError = AxiosError<EarnSubscriptionAutoRenewalResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxEarnSubscriptionsAutoRenewal>>, TError,{data: EarnSubscriptionAutoRenewalRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxEarnSubscriptionsAutoRenewal>>, {data: EarnSubscriptionAutoRenewalRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxEarnSubscriptionsAutoRenewal(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxEarnSubscriptionsAutoRenewal>>, TError, {data: EarnSubscriptionAutoRenewalRequest}, TContext>(mutationFn, mutationOptions)
    }
    